import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={21.133}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 14590 17744"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#333}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313089360">
        <path
          d="M4196 11044c203 57 464 224 695 305 249 87 504 144 788 163 634 42 1147-30 1662-263 555-251 800-433 1548-350 533 60 909 378 1423 516-177 767-683 1325-1115 1663-1900 1491-4714 259-5001-2034zm-437-537c28 805 142 1331 561 2000 87 138 287 397 377 482 148 139 255 267 433 399 1758 1305 4084 838 5209-1005 188-308 417-857 446-1287-712-66-1033-443-1647-562-734-144-1275-5-1848 296-507 265-1219 364-1862 247-652-120-1018-502-1669-570z"
          className="fil0"
        />
        <path
          d="M14142 3620c-30 394-4 891-4 1296v8981c0 862 34 1721-1 2575-16 386-243 630-511 753-260 119-883 71-1203 71H2140c-351 0-929 50-1213-88-262-128-471-386-475-787-9-848 0-1701 0-2550V6165c0-817 41-1743-3-2558l13693 13zM449 3157c48-1143-342-2671 866-2702 394-10 802-1 1197-1h9566c395 0 803-10 1197 1 393 10 621 205 756 436 194 333 100 1767 108 2265-257 59-1370 14-1716 14H3867c-466 0-3197 32-3418-13zM1078 41C550 134 165 516 49 1017c-87 379-31 1524-32 1986v12116c0 1038-273 2613 1406 2612 743 0 11761 39 12098-20 512-91 907-483 1020-980 75-329 32-5760 32-6022V2631c0-1031 277-2613-1406-2612L3070 20c-511 0-1548-57-1992 21z"
          className="fil0"
        />
        <path
          d="M3104 12117c27-335 74-13-48-437-44-157-76-289-105-453-364-2069 742-4067 2720-4878 1188-488 2525-378 3614 166 899 449 1711 1272 2115 2319 230 594 340 1208 298 1900-38 615-141 832-292 1349-99 341-611 1115-855 1350-118 114-174 169-278 279-56 60-215 179-294 239-346 262-642 438-1067 607-1465 581-3100 300-4301-607-379-286-814-744-1064-1168-33-56-60-116-96-170-187-280-66-92-195-368-73-158-25-64-152-128zm-634-1196c202 2499 2497 4611 5275 4357 2535-232 4626-2466 4376-5282-63-702-290-1347-569-1869-155-288-315-497-494-730l-285-325c-177-186-432-397-641-555-877-666-2172-1000-3301-890-1487 145-2607 859-3459 1983-702 926-998 2115-902 3311z"
          className="fil0"
        />
        <path
          d="M4279 9467c338-1272 1615-2403 3264-2282 1417 104 2724 1279 2852 2677-232-78-440-216-688-305-255-91-502-143-791-166-2024-161-2160 1216-3968 365l-669-289zm-473 319c115 58 302 70 440 109 140 41 280 102 404 160 262 122 474 249 791 315 1661 342 1865-861 3728-542 656 113 987 492 1659 569 19-490-87-1023-260-1430-144-338-417-808-670-1046-71-66-144-138-211-208-195-198-478-392-744-529-1621-837-3532-327-4513 1060-281 398-581 1002-624 1542zM2013 2090c-16-94-6-307-6-412 0-140 2-245 125-294 99-40 1422-20 1636-20 251 0 604-72 636 192 111 891-173 706-917 706h-824c-231 0-608 69-650-172zm-353 43c52 388 367 485 700 484 390-1 780-1 1170-1 742 0 1385 159 1225-1122-22-176-137-311-229-379-139-101-274-105-476-104H2880c-344 0-814-75-1039 147-101 99-174 203-185 390-7 137-13 457 4 585zM10480 1951c-216 589-1040 230-828-300 214-534 1017-215 828 300zm-1320 0c152 1149 1967 953 1806-259-156-1171-1970-981-1806 259zM7289 1398c543-194 808 647 271 831-535 184-862-620-271-831zm-780 524c97 1136 1940 1032 1816-202-116-1160-1924-1064-1816 202z"
          className="fil0"
        />
        <path
          d="M13131 1950c-213 561-1049 255-839-297 198-521 1035-223 839 297zm-1336-29c52 466 468 830 998 792 1192-86 1057-1933-198-1796-476 52-858 478-800 1004z"
          style={{
            fill: "#323232",
          }}
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
